import api from "../../../components/commonComponents/axiosSetup";

export const getUserDetails = () => {
  try {
    return JSON.parse(localStorage.getItem("userInformation")) || null;
  } catch (error) {
    console.error("Failed to parse userInfo:", error);
    return null;
  }
};

export const isSuperAdmin = () => {
  return getUserDetails()?.superAdmin;

};

export const accountId =()=>{
  const id = getUserDetails()?.id;
  return Number(id);
}

export const accountCreationLimit =()=>{
  const remainingChildAccounts = getUserDetails()?.remainingChildAccounts;
  return Number(remainingChildAccounts);
}

export const parentAccountId =()=>{
  const id = getUserDetails()?.id;
  return Number(id);
}
export const companyId =()=>{
  const id = getUserDetails()?.companyId;
  return Number(id);
}
export const accountLimit =()=>{
  const accountLimitNUmber = getUserDetails()?.remainingChildAccounts;
  return Number(accountLimitNUmber);
}

export const accountEmail = () => getUserDetails()?.email || null;
export const accountName = () => getUserDetails()?.accountName || null;

export const userPermissions = () => getUserDetails()?.permissions || {};


export const isAdminUser = () => {
  const userDetails = getUserDetails();
  return userDetails?.adminUser 
};


export const isUser =()=>{
    const userDetails = getUserDetails();
    return userDetails?.companyUser
}

export const isUserName =()=>{
    const userDetails = getUserDetails();
    return userDetails?.userName
}

export const isCompanyID =()=>{
    const userDetails = getUserDetails();
    return userDetails?.companyId
}

